import { publicUrlFor } from "../../../../../globals/constants";
import JobZImage from "../../../../common/jobz-img";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { candidate, canRoute } from "../../../../../globals/route-names";

function SectionUploadCV() {
    const { t } = useTranslation();

    return (
        <>
            <div className="section-full p-t120 p-b120 twm-explore-area bg-cover " style={{ backgroundImage: `url(${publicUrlFor("images/background/bg-1.jpg")})` }}>
                <div className="container">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-lg-4 col-md-12">
                                <div className="twm-explore-media-wrap">
                                    <div className="twm-media">
                                        <JobZImage src="images/gir-large-2.png" alt="#" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-12">
                                <div className="twm-explore-content-outer">
                                    <div className="twm-explore-content">
                                        <div className="twm-l-line-1" />
                                        <div className="twm-l-line-2" />
                                        <div className="twm-r-circle-1" />
                                        <div className="twm-r-circle-2" />
                                        <div className="twm-title-small">{t("Explore a new life")}</div>
                                        <div className="twm-title-large">
                                            <h2>{t("We are an innovative platform that empowers job seekers.")} </h2>
                                            <p>{t("We harness artificial intelligence to connect candidates with their dream jobs using automated applications.")}</p>
                                        </div>
                                        <div className="twm-upload-file">
                                            <NavLink to={canRoute(candidate.DASHBOARD)}>
                                                <button type="button" className="site-button">{t("Upload CV")} <i className="feather-upload" /></button>
                                            </NavLink>
                                        </div>
                                    </div>
                                    <div className="twm-bold-circle-right" />
                                    <div className="twm-bold-circle-left" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionUploadCV;